import React from 'react';
import { Box, Paper } from '@mui/material';

interface StepContainerProps {
    children: React.ReactNode;
    sx?: any;
}

const StepContainer: React.FC<StepContainerProps> = ({ children, sx = {} }) => {
    return (
        <Box sx={{ p: 2, ...sx }}>
            {children}
        </Box>
    );
};

export default StepContainer;
